import myFetchWithId, { exportWithId } from '../helpers/myFetch';
import { detailFormatToSample } from '../helpers/dataTransfer';
import { requestFetchApi , receiveFetchApi } from './search.actions';
import {kolData} from '../constants'

export function fetchKolVibe(keyword, widgetId, isDashboard, posttype, sentiment, maxCount, voice) {
  let params = {
    text: keyword,
    fieldname: 'glb_author,glb_sentiment',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount',
    fillgap: 'Y',
    score: voice
  };
  if (isDashboard) {
    // delete params.glb_posttype;
    // delete params.glb_sentiment;
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return myFetchWithId(widgetId, false, true)(process.env.REACT_APP_LOWI_MULTI, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveKolVibe(json, maxCount))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}

function receiveKolVibe(detailJson, maxCount) {
  const json = detailFormatToSample(detailJson, true);
  let noData = json.values.response==='no-data';

  if (noData) {
    return {
      type:kolData.RECEIVE,
      name: [],
      receivedAt: Date.now()
    };
  } else {
    let kolName = Object.keys(json.values.tagCounts);
    let tagCounts = Object.entries(json.values.tagCounts).map(([name, y]) => ({ name, y }));
    let value = json.values.tagValues;
    let positive = [];
    let negative = [];
    let neutral = [];
    let dataForBubble = [];
    for (var prop in value) {
      positive.push(value[prop].POSITIVE);
      negative.push(value[prop].NEGATIVE);
      neutral.push(value[prop].NEUTRAL);
      dataForBubble.push({
        x: value[prop].NEGATIVE,
        y: value[prop].POSITIVE,
        z: value[prop].NEGATIVE + value[prop].POSITIVE + value[prop].NEUTRAL,
        neutral: value[prop].NEUTRAL,
        name: prop
      })
    };
    // if there is 'ANONYMOUS' indside the kol return, take off it
    const index = kolName.findIndex(name => name === 'ANONYMOUS');
    if (index !== -1) {
      kolName.splice(index, 1);
      positive.splice(index, 1);
      negative.splice(index, 1);
      neutral.splice(index, 1);
      tagCounts.splice(index, 1);
      dataForBubble.splice(index, 1);
    } else {
      // if there is no ANONYMOUS, take off the no.11 kol
      kolName.splice(maxCount -1 , 1);
      positive.splice(maxCount -1 , 1);
      negative.splice(maxCount -1 , 1);
      neutral.splice(maxCount -1 , 1);
      tagCounts.splice(maxCount -1 , 1);
      dataForBubble.splice(maxCount -1 , 1);
    }

    const computeAvg = (arr) => {
      let sum, avg = 0;
      if (arr.length) {
        sum = arr.reduce(function(p, c) { return p + c;});
        avg = sum / arr.length;
      }
      return avg;
    };

    return {
      type:kolData.RECEIVE,
      name: kolName,
      kolTagCounts: tagCounts,
      kolPositive: positive,
      kolNegative: negative,
      kolNeutral: neutral,
      dataForBubble: dataForBubble,
      avgPositive: computeAvg(positive),
      avgNegative: computeAvg(negative),
      receivedAt: Date.now()
    }
  }
}

export function exportKolVibe(keyword, widgetId, isDashboard, posttype, sentiment, maxCount) {
  let params = {
    text: keyword,
    fieldname: 'glb_author,glb_sentiment',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount'
    };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }
  return exportWithId(widgetId, false, true)(process.env.REACT_APP_EXPORT_COMPLEX, params);
}





export function fetchKolDate(keyword, widgetId, isDashboard, posttype, sentiment, maxCount, voice) {
  let params = {
    text: keyword,
    fieldname: 'glb_author,GLBTIME_YMD',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount',
    fillgap: 'Y',
    score: voice
  };
  if (isDashboard) {
    // delete params.glb_posttype;
    // delete params.glb_sentiment;
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return myFetchWithId(widgetId, false, true)(process.env.REACT_APP_LOWI_MULTI, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveKolDate(json, maxCount))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}

function receiveKolDate(detailJson, maxCount) {
  const json = detailFormatToSample(detailJson, true);
  let noData = Object.values(detailJson.values).length === 0
  
  if(noData){
    return {
      type:kolData.RECEIVE,
      value: [],
      receivedAt: Date.now()
    };
  } else {
    const data = json.values.tagValues;
    // use first object to set the date
    const firstObject = data[Object.keys(data)[0]];
    const date = Object.keys(firstObject);
    const payload = [];

    for (var prop in data) {
      let name = prop;
      let y = Object.values(data[prop]);
      payload.push({name, y});
    };
    // if there is 'ANONYMOUS' indside the kol return, take off it
    const index = Object.keys(data).findIndex(name => name === 'ANONYMOUS');
    if (index !== -1) {
      payload.splice(index, 1);
    } else {
      // if there is no ANONYMOUS, take off the no.11 kol
      payload.splice(maxCount -1, 1);
    }
    return {
      type:kolData.RECEIVE,
      date: date,
      value: payload,
      receivedAt: Date.now()
    }
  }
}

export function exportKolDate(keyword, widgetId, isDashboard, posttype, sentiment, maxCount) {
  let params = {
    text: keyword,
    fieldname: 'glb_author,GLBTIME_YMD',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount'
    };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }
  return exportWithId(widgetId, false, true)(process.env.REACT_APP_EXPORT_COMPLEX, params);
}



// WEBPACK FOOTER //
// ./src/actions/widgetKol.actions.js